import { PrimaryFormAutoComplete } from "react-common-ui-library";
import {
  NAME_SEX,
  SEX_LABEL,
  SEX_REQUIRED_ERROR,
} from "../../../Constants/LinkMyApplicationConstants";
import { useSelector } from "react-redux";
import { manageReferenceDataSelector } from "../../../Selectors/ReferenceDataSelector";

/**
 * @description Sex dropdown component
 * @returns {ReactNode} Autocomplete with the options from Sex
 */
const SearchHAPIdSex = () => {
  const { sexDropdownValues } = useSelector((state) =>
    manageReferenceDataSelector(state)
  );

  return (
    <PrimaryFormAutoComplete
      formProps={{
        name: NAME_SEX,
        rules: {
          required: {
            value: true,
            message: SEX_REQUIRED_ERROR,
          },
        },
      }}
      labelProps={{ labelText: SEX_LABEL, required: true }}
      fieldProps={{ autoCompleteOptions: sexDropdownValues }}
    />
  );
};

export default SearchHAPIdSex;
